module.exports = __webpack_public_path__ + "img/1-1.1239f3a2.svg";